import {
    FetchUserMetricsInfo,
    UpdateTimeSpentAndStreakInfo,
    UserMetricsType,
} from "@lifeat/shared/data-models/user/UserMetrics/UserMetricsEntity";
import * as DateUtil from "@lifeat/shared/util/DateUtil";
import { MILLISECONDS_PER_MINUTE } from "@lifeat/shared/util/DateUtil";
import { functions } from "@firebase-local/firebase";
import { All_USER_METRICS_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";
import { logError } from "@service/ConsoleLoggerService";

/**
 * Fetch time spent and focus time metrics
 * @param {FetchUserMetricsInfo} data Data defining dates to fetch for
 * @param {(data: UserMetricsType) => void} callback callback function for returned data
 */
export const fetchUserMetrics = (data: FetchUserMetricsInfo, callback: (data: UserMetricsType) => void) => {
    functions
        .httpsCallable(All_USER_METRICS_FUNCTIONS.FetchUserMetrics)(data)
        .then((result) => {
            if (result.data) {
                callback(result.data);
            }
        })
        .catch((error) => {
            logError(`Error fetching time spent ${error}`);
        });
};

/**
 * Update time spent metric
 * @param {UpdateTimeSpentInfo} data Data for updating the time spent
 */
export const updateTimeSpent = (data: UpdateTimeSpentAndStreakInfo) => {
    functions
        .httpsCallable(All_USER_METRICS_FUNCTIONS.UpdateTimeSpent)(data)
        .catch((error) => {
            logError(`There was an error [code: ${error.code}, message: ${error.message}] ` + `updating time spent.`);
        });
};

/**
 * Update focus time metric
 * @param duration
 */
export const updateFocusTime = (duration: number) => {
    const today = new Date();
    const formattedDate = parseInt(DateUtil.formatDateStringYYYYMMDD(today));
    const data = { date: formattedDate, duration: duration * MILLISECONDS_PER_MINUTE };
    functions
        .httpsCallable(All_USER_METRICS_FUNCTIONS.UpdateFocusTime)(data)
        .catch((error) => {
            logError(`There was an error [code: ${error.code}, message: ${error.message}] ` + `updating focus time.`);
        });
};
